export const isShiftClickEvent = (
  value: Event | Record<string, unknown> | null | undefined,
): boolean => Boolean(value && Reflect.get(value, 'shiftKey'));

export const rangeSelectIds = ({
  ids,
  fromId,
  toId,
}: {
  ids: readonly string[];
  fromId: string;
  toId: string;
}): string[] => {
  const fromIndex = ids.indexOf(fromId);
  const toIndex = ids.indexOf(toId);

  if (fromIndex < 0 || toIndex < 0) {
    return fromIndex >= 0 ? [fromId] : toIndex >= 0 ? [toId] : [];
  }

  const start = Math.min(fromIndex, toIndex);
  const end = Math.max(fromIndex, toIndex);

  return ids.slice(start, end + 1);
};

export const shouldFetchNextHarPage = ({
  lastDisplayedRowIndex,
  displayedRowCount,
  hasNextPage,
  isFetchingNextPage,
}: {
  lastDisplayedRowIndex: number;
  displayedRowCount: number;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}): boolean => {
  if (!hasNextPage || isFetchingNextPage || displayedRowCount === 0) {
    return false;
  }

  return lastDisplayedRowIndex >= displayedRowCount - 5;
};

const HAR_SELECT_ALL_SOURCES = new Set([
  'uiSelectAll',
  'uiSelectAllFiltered',
  'keyboardSelectAll',
]);

export const isHarSelectAllEvent = (source: string): boolean =>
  HAR_SELECT_ALL_SOURCES.has(source);

const HAR_USER_CLEAR_SELECTION_SOURCES = new Set([
  'checkboxSelected',
  'uiSelectAll',
  'uiSelectAllFiltered',
  'keyboardSelectAll',
  'rowClicked',
  'rowDeselected',
  'spacePressed',
]);

export const shouldApplyHarGridSelection = ({
  source,
  nextIds,
  selectedIds,
}: {
  source: string;
  nextIds: readonly string[];
  selectedIds: readonly string[];
}): boolean => {
  if (nextIds.length > 0 || selectedIds.length === 0) {
    return true;
  }

  return HAR_USER_CLEAR_SELECTION_SOURCES.has(source);
};

export const shouldContinueHarFilterPaging = ({
  hasActiveFilters,
  hasNextPage,
  isFetchingNextPage,
  loadedCount,
  hasFetchError,
}: {
  hasActiveFilters: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  loadedCount: number;
  hasFetchError: boolean;
}): boolean =>
  hasActiveFilters &&
  hasNextPage &&
  !isFetchingNextPage &&
  loadedCount > 0 &&
  !hasFetchError;
